"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushValue = void 0;
var pushValue = function (option, value, multiple, forcedValue) {
    function createArray() {
        if (Array.isArray(value)) {
            return Array.from(value);
        }
        return typeof value === 'undefined' ? [] : [value];
    }
    if (multiple) {
        return createArray()
            .filter(function (v) { return (option.value === forcedValue ? v === forcedValue : v !== forcedValue); })
            .concat([option.value]);
    }
    return option.value;
};
exports.pushValue = pushValue;
//# sourceMappingURL=pushValue.js.map